import React from 'react'

import { Clock as ClockIcon } from 'react-feather'
import { Box, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useAuthSupplier from 'hooks/useAuthSupplier'

import useStyles from './styles'

const EndDate = () => {
  const classes = useStyles()
  const { companySupplier } = useAuthSupplier()

  if (!companySupplier) {
    return <Skeleton variant="rect" animation="wave" width={200} height={52} />
  }

  const { remainingDays } = companySupplier

  return (
    <Box className={classes.root}>
      <ClockIcon style={{ marginRight: 4 }} size={32} />
      <Box className={classes.content}>
        {remainingDays === 0 && (
          <>
            <Typography className={classes.label}>PRAZO RESTANTE</Typography>
            <Typography className={classes.overdue}>HOJE</Typography>
          </>
        )}
        {(remainingDays > 0 || remainingDays === '-') && (
          <>
            <Typography className={classes.label}>PRAZO RESTANTE</Typography>
            <Typography className={classes.dayCounter}>
              {remainingDays}
            </Typography>
            <Typography className={classes.label}>DIAS</Typography>
          </>
        )}
        {remainingDays < 0 && (
          <>
            <Typography className={classes.overdue}>ATRASADO</Typography>
            <Typography className={classes.label}>A</Typography>
            <Typography className={classes.dayCounter}>
              {Math.abs(remainingDays)}
            </Typography>
            <Typography className={classes.label}>DIAS</Typography>
          </>
        )}
      </Box>
    </Box>
  )
}

export default EndDate
